<template>
    <!-- 称呼 -->
  <div class="ceping82-call animated fadeInRight">
      <img class="bg" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/cp82-b2.png" alt="">
      <div class="inp-group">
          <label for="">请输入称呼：</label>
          <input type="text" v-model="name" placeholder="限定8个汉字内" />
      </div>
      <div class="hr"></div>
      <div :class="['btn',bool?'on':'',h?'top':'bottom']">
          <a @click="toBlessHandle()">下一步</a>
      </div>
      
  </div>
</template>

<script>
import { getData,saveData } from '@/api/measurement'
import { deepCopy } from "@/utils/tools";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            bool:false,
            h:false,
            name:'',
            cid:82,
            callObj:{},
            mailObject:{}
        }
    },
    mounted(){
        // 滚动的时候才会触发
        $(window).scroll(()=>{
            this.bool = $(document).scrollTop() >55?true:false;
            this.h = ((document.body.offsetHeight | document.body.clientHeight)>474) || this.bool?true:false;
        });
        // 判断body内容的高度（只在页面第一次加载的时候触发）
        this.h = ((document.body.offsetHeight | document.body.clientHeight)>474) || this.bool?true:false;
        
    },
    methods:{
        // 进入选择祝福语
        toBlessHandle(){
            if(!this.name){
                this.$toast('请先填写称呼！');
                return
            }
            //调用加载中
            this.$emit('loadingHandle',true,"正在提交...");
            let obj = deepCopy(this.callObj);
            obj['name'] = this.name;
            this.mailObject['ceping82'] = obj;
            saveData({
                cid:this.cid,
                data:JSON.stringify(this.mailObject)
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if (data.code == "10002") {
                    this.$toast(data.data.msg || data.msg || data.data.detail);
                    return
                }
                this.$router.push('/ceping82_blessing');
            });
        },
        // 初始化获取数据
        pullData(){
            document.title = "写下你对TA的“称呼”吧"
            //调用加载中
            this.$emit('loadingHandle',true,"正在铺纸ヾ(◍°∇°◍)ﾉﾞ...");
            getData({
                cid:this.cid
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if (data.code == "10002") {
                    this.$toast(data.data.msg || data.msg || data.data.detail);
                    return
                }
                if(data.data){
                    this.mailObject = JSON.parse(data.data);
                    this.callObj =JSON.parse(data.data) && JSON.parse(data.data).ceping82?JSON.parse(data.data).ceping82:{};
                    if(this.callObj.name){
                        this.name = this.callObj.name;
                    }
                }
            });
            shareCon("index", this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background:url('https://themes-cdn.xjy.cn/statics/career/images/ceping82/bg-cover.png') bottom;
    }
</style>
<style lang="scss" scoped>
.ceping82-call{
    overflow-y: auto;
    position: relative;
    z-index: 1;
    .bg{
        width: 100%;
    }
    .inp-group{
        position: absolute;
        top: 650px;
        left: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        transform: translateX(-50%);
        text-align: center;
        z-index: 2;
        label{
            font-size: 28px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #875233;
            line-height: 40px;
        }
        input{
            font-size: 28px;
            color: #323333;
            width: 225px;
            line-height: 40px;
            border: none;
            background-color: transparent;
        }
    }
    .hr{
        position: absolute;
        top: 700px;
        left: 50%;
        transform: translateX(-50%);
        height: 2px;
        width: 513px;
        z-index: 2;
        background: linear-gradient(to right,#F1E2DB,#EBBFA4,#F7EBE4);
    }
    .btn{
        display: block;
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        
        a{
            width: 300px;
            line-height: 80px;
            height: 80px;
            background: linear-gradient(180deg, #FF855D 0%, #D13E1D 100%);
            box-shadow: 0px 2px 6px 0px rgba(179, 31, 0, 0.43);
            border-radius: 40px;
            display: block;
            text-align: center;
            text-shadow: 0px 2px 4px rgba(221, 41, 0, 0.5);
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            animation: scaleDraw 2s  infinite;
        }
    }
    .btn.top{
        top: 1034px;
    }
    .btn.bottom{
        bottom: 110px;
    }
    .btn.on{
        position: absolute;
    }
}
</style>